import { FormControl } from 'bold-ui'
import { SwitchField, SwitchFieldProps } from 'components/form'
import { resolveName } from 'components/form/final-form/hooks/useField'
import React from 'react'
import { useField } from 'react-final-form'

export interface VacinadoExteriorFieldProps extends Omit<SwitchFieldProps, 'label'> {
  label: string
}

export function VacinadoExteriorField(props: VacinadoExteriorFieldProps) {
  const { label, name, ...rest } = props

  const {
    input: { value: vacinadoNoExterior },
  } = useField(resolveName(name), { subscription: { value: true } })

  return (
    <FormControl label={label}>
      <SwitchField name={name} label={vacinadoNoExterior ? 'Sim' : 'Não'} {...rest} />
    </FormControl>
  )
}
